
const url = {
  dev: 'http://10.10.110.139/',
  // dev:'http://172.18.8.69/',//陶国梁电脑
  // dev: 'http://172.18.0.76/', // 钟毅电脑
  uat: 'http://gateway.ops.liuheco.com/',
  production: 'https://hopeyegateway.oak.net.cn/'
}
let urlField = process.env.NODE_ENV || 'dev'
export const baseUrl = url[urlField] || 'http://10.10.110.139/'
// export const baseUrl = url[urlField] || 'http://172.18.9.124/' // 钟毅电脑

// app 路径
// 测试环境：http://10.10.110.139:9090
// UAT环境：http://appweb.ops.liuheco.com
// 生产环境：https://hopeye.oak.net.cn/

// 云平台地址：
// 测试环境：http://10.10.110.139:8080
// UAT环境：http://adminweb.ops.liuheco.com
// 生产环境：https://hopeyeadmin.oak.net.cn/

const appUrlObj = {
  dev: 'http://10.10.110.139:9090',
  // dev: '172.18.9.124',
  uat: 'http://appweb.ops.liuheco.com',
  product: 'https://hopeye.oak.net.cn',
}
let src = window.location.href
const urlObj = {
  dev: 'http://10.10.110.139:8080',
  // dev: 'http://localhost:3001',
  uat: 'http://adminweb.ops.liuheco.com',
  product: 'https://hopeyeadmin.oak.net.cn',
}
let feild = 'dev'
if(src.indexOf(appUrlObj.uat) >= 0){
  feild = 'uat'
}else if(src.indexOf(appUrlObj.product) >= 0){
  feild = 'product'
}


const trackUrlObj = {
  dev: 'http://tracking.ops.liuheco.com/tracking_server/tracking/data/collection',
  uat: 'http://tracking.ops.liuheco.com/tracking_server/tracking/data/collection',
  product: 'https://tracking.oak.net.cn/tracking_server/tracking/data/collection',
}
const appCodeObj = {
  dev: 'hopeyeNhf',
  uat: 'hopeyeNhf',
  product: 'hopeyenhf',
}
const appSecretObj = {
  dev: 'Rk7oTkOUkKq9NAAcHC3v5bavaEIAEF71',
  uat: 'Rk7oTkOUkKq9NAAcHC3v5bavaEIAEF71',
  product: 'Rk7oTkOUkKq9NAAcHC3v5bavaEIAEF71',
}
export const adminUrl = urlObj[feild]
export const trackUrl = trackUrlObj[feild]
export const appCode = appCodeObj[feild]
export const appSecret = appSecretObj[feild]
